import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {PATHS} from "@/constants/routes";
import {useAuthStore} from "@/store/auth.store";
import ReferralsPage from "./ReferralsPage";

const ReferralsRoute = () => {
  const navigate = useNavigate();
  const status = useAuthStore(state => state.status);
  const hydrate = useAuthStore(state => state.hydrate);

  useEffect(() => {
    if (status === "checking") hydrate();
  }, [status, hydrate]);

  useEffect(() => {
    if (status === "unauthenticated") navigate(PATHS.authLogin, {replace: true});
  }, [status, navigate]);

  if (status !== "authenticated") {
    return <main className="min-h-screen w-full bg-[var(--color-bg)]" />;
  }

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <ReferralsPage />
    </main>
  );
};

export default ReferralsRoute;
